import { BASE_URL, getHeaders } from "../utils/serviceHelper";

export const getMentorDashboard = async (mentorId, syllabusId, sessionId) => {
    const res = await fetch(
        `${BASE_URL}/dashboard/mentor/${mentorId}/${syllabusId}/${sessionId}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            headers: getHeaders(),
        },
    );
    return await res.json();
};

export const getUserDashboard = async (userId, syllabusId, sessionId) => {
    const res = await fetch(
        `${BASE_URL}/dashboard/user/${userId}/${syllabusId}/${sessionId}`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            headers: getHeaders(),
        },
    );
    return await res.json();
};

